var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useState } from "react";
import { useQuery } from "react-query";
import { useOkapiKy } from "@folio/stripes/core";
import { fetchCollections } from "../api/collectionsService";
import { DEFAULT_PAGE_SIZE } from "../utils/constants";
/**
 * One page of the collections list.
 *
 * @param appliedFilters filters the search sends
 * @param pageSize page size
 * @param enabled false while the filters are still being resolved — nothing is
 *   searched and `isWaitingForFilters` is true
 */
export var useCollectionsData = function (appliedFilters, pageSize, enabled) {
    var _a;
    if (pageSize === void 0) { pageSize = DEFAULT_PAGE_SIZE; }
    if (enabled === void 0) { enabled = true; }
    var ky = useOkapiKy();
    var _b = useState(0), pageOffset = _b[0], setPageOffset = _b[1];
    var _c = useState(0), totalRecords = _c[0], setTotalRecords = _c[1];
    var _d = useQuery(["collections", appliedFilters, pageOffset, pageSize], function () {
        return fetchCollections(ky, __assign(__assign({}, appliedFilters), { offset: pageOffset, limit: pageSize }));
    }, {
        keepPreviousData: true,
        enabled: enabled,
        onSuccess: function (responseData) {
            var _a;
            setTotalRecords((_a = responseData.totalRecords) !== null && _a !== void 0 ? _a : 0);
        },
    }), data = _d.data, isLoading = _d.isLoading, isError = _d.isError, isFetched = _d.isFetched;
    var collectionsData = (_a = data === null || data === void 0 ? void 0 : data.items) !== null && _a !== void 0 ? _a : [];
    var fetchMoreData = function (offset) {
        setPageOffset(offset);
    };
    var resetPageOffset = function () { return setPageOffset(0); };
    return {
        collectionsData: collectionsData,
        totalRecords: totalRecords,
        isLoading: isLoading,
        /** true while the search waits for its filters (`enabled` false) — no request is running */
        isWaitingForFilters: !enabled,
        isError: isError,
        isFetched: isFetched,
        fetchMoreData: fetchMoreData,
        resetPageOffset: resetPageOffset,
        pageOffset: pageOffset,
        pageSize: pageSize,
    };
};
